// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_bg_placeholder, s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_btn_green, s_button_rectangle_white, s_buttonpowerbg, s_buttonpower_disabled } from "../AssetDefinitions/ImageDefinitions";
import { s_smokePuff } from "../AssetDefinitions/SpineDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
tgfSettings.dialogDefaults.PowerupRewardDialog = {
    width: 800,
    height: 500,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    includeBackground: false,
    headerKey: "REWARD_POPUP_HEADER",
    origin: "shortcut",
    components: [] // The additional components to add
};
export var PowerupRewardDialog = function (properties) {
    "use strict";
    this.name = "PowerupRewardDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.PowerupRewardDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(PowerupRewardDialog, DialogBase);
PowerupRewardDialog.prototype.doPrepare = function () {
    "use strict";
    if (this.includeBackground) {
        this.lobbyBG = new ComponentPicture({
            image: s_bg_placeholder,
            xScale: 2,
            yScale: 2
        });
        this.addComponent(this.lobbyBG);
    }
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({
        image: s_popup_bottom,
        x: tgfGraphics.areaWidth / 2,
        y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2
    }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText(this.headerKey),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.centerLabel = new ComponentLabel({
        text: tgfDictionary.getText("REWARD_POPUP_BODY_1_TEXT"),
        font: this.font,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - 160,
        splitLines: true,
        width: this.width - 20,
    });
    this.addComponent(this.centerLabel);
    this.initPowerups();
    this.buttonContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + 150
    });
    this.addComponent(this.buttonContainer);
    this.acceptButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText("BTN_REWARD_POPUP"),
        fontUp: this.buttonFont,
        onClick: this.onAccept.bind(this),
    });
    this.buttonContainer.addComponent(this.acceptButton);
    AngryAnalytics.reportScreen(this.origin, "powerup");
};
PowerupRewardDialog.prototype.initPowerups = function () {
    this.powerupBar = new ComponentPicture({
        image: s_button_rectangle_white,
        xScale: 1.8,
        yScale: 1.2,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - 30,
    });
    this.powerupImages = [];
    this.powerupBackgrounds = [];
    this.whiteSpheres = [];
    this.spines = [];
    var powerups = inventoryController.getPowerUpSlots();
    var spacing = 130;
    var leftY = -spacing * ((powerups.length - 1) / 2);
    for (var i = 0; i < powerups.length; i++) {
        this.whiteSpheres[i] = new ComponentPicture({
            image: s_buttonpowerbg,
            x: leftY + spacing * i,
            xScale: 1.07,
            yScale: 1.07
        });
        this.powerupBar.addComponent(this.whiteSpheres[i]);
        var bgImg;
        if (powerups[i].powerUp != -1) {
            bgImg = PowerUpSettings.options[powerups[i].powerUp].bgImg;
        }
        else {
            bgImg = s_buttonpower_disabled;
        }
        this.powerupBackgrounds[i] = new ComponentPicture({
            image: bgImg,
            x: -0,
            y: -8,
            xScale: 1.1,
            yScale: 1.1
        });
        this.whiteSpheres[i].addComponent(this.powerupBackgrounds[i]);
        if (powerups[i].powerUp != -1) {
            this.powerupImages[i] = new ComponentPicture({
                image: PowerUpSettings.options[powerups[i].powerUp].image,
                xScale: 1.1,
                yScale: 1.1,
                x: -PowerUpSettings.options[powerups[i].powerUp].iconOffset.x,
                y: -PowerUpSettings.options[powerups[i].powerUp].iconOffset.y,
            });
            this.whiteSpheres[i].addComponent(this.powerupImages[i]);
        }
        else {
            this.powerupImages[i] = new ComponentPicture({
                xScale: 1.1,
                yScale: 1.1
            });
            this.whiteSpheres[i].addComponent(this.powerupImages[i]);
        }
        this.spines[i] = new ComponentSpine({
            spineAnimation: s_smokePuff,
            alpha: 0,
        });
        this.whiteSpheres[i].addComponent(this.spines[i]);
    }
    this.addComponent(this.powerupBar);
};
PowerupRewardDialog.prototype.onAccept = function () {
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    this.close();
    AngryAnalytics.reportRewardContinueAction(this.origin);
};
PowerupRewardDialog.prototype.reloadPowerups = function (showAnimation) {
    var self = this;
    if (this.reverseAnimation) {
        for (var i = this.whiteSpheres.length - 1; i >= 0; i--) {
            if (showAnimation) {
                setTimeout(function (index) {
                    self._reloadPowerup(index, true);
                }, 250 * (this.whiteSpheres.length - i), i);
            }
            else {
                this._reloadPowerup(i, false);
            }
        }
    }
    else {
        for (var i = 0; i < this.whiteSpheres.length; i++) {
            if (showAnimation) {
                setTimeout(function (index) {
                    self._reloadPowerup(index, true);
                }, 250 * (i + 1), i);
            }
            else {
                this._reloadPowerup(i, false);
            }
        }
    }
};
PowerupRewardDialog.prototype._reloadPowerup = function (index, showAnimation) {
    var self = this;
    var powerup = inventoryController.getPowerUpSlots()[index].powerUp;
    if (showAnimation) {
        var spine = this.spines[index];
        spine.setAlpha(1);
        spine.setAnimation(PowerUpSettings.options[powerup].smokePuff, function () {
            self.spines[index].setAlpha(0);
        });
        setTimeout(function (index, powerup) {
            self._changeImage(index, powerup);
            self.spines[index].bringToFront();
        }, 250, index, powerup);
    }
    else {
        this._changeImage(index, powerup);
    }
};
PowerupRewardDialog.prototype._changeImage = function (index, powerUp) {
    this.powerupBackgrounds[index].changeImage(PowerUpSettings.options[powerUp].bgImg);
    this.powerupImages[index].changeImage(PowerUpSettings.options[powerUp].image);
    this.powerupImages[index].setPosition(-PowerUpSettings.options[powerUp].iconOffset.x, -PowerUpSettings.options[powerUp].iconOffset.y);
};
PowerupRewardDialog.prototype.close = function () {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
PowerupRewardDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
